/* eslint-disable react-refresh/only-export-components */
// This context module intentionally exports both a provider component and
// related utilities (ref + hook) in the same file for cohesion.
import { createContext, useContext, useState, type ReactNode } from "react";

/**
 * Module-level ref so that the Axios interceptor in apiClient.ts can read the
 * assumed role synchronously — interceptors can't use React hooks.
 * The context provider keeps this ref in sync with React state.
 */
export const assumedRoleRef: { current: string | null } = { current: null };

interface AssumedRoleContextType {
  assumedRole: string | null;
  setAssumedRole: (role: string | null) => void;
}

const AssumedRoleContext = createContext<AssumedRoleContextType>({
  assumedRole: null,
  setAssumedRole: () => {},
});

export function AssumedRoleProvider({ children }: { children: ReactNode }) {
  const [assumedRole, setAssumedRoleState] = useState<string | null>(null);

  const setAssumedRole = (role: string | null) => {
    setAssumedRoleState(role);
    assumedRoleRef.current = role;
  };

  return (
    <AssumedRoleContext.Provider value={{ assumedRole, setAssumedRole }}>
      {children}
    </AssumedRoleContext.Provider>
  );
}

export function useAssumedRole() {
  return useContext(AssumedRoleContext);
}
